import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { useMediaQuery, useTheme } from '@mui/material';
import { useFormContext, } from "react-hook-form-mui";
import { useI18N } from '../../context/I18NContext';
import useWidgetStore from '../../store/useWidgetStore';
import { CustomSelectElement } from '../../layouts/Theme';
import useDataStore from '../../store/useDataStore';
export default function ObjectSelectPicker(props) {
    var _a, _b;
    const theme = useTheme();
    const { t } = useI18N();
    const isLarge = useMediaQuery(theme.breakpoints.up('sm'));
    const { selectedApptype, selectedProduct, selectedCategory, selectedGroup, selectedResource, setSelectedApptype, setSelectedGroup, setSelectedResource, getSourceHelpers } = useWidgetStore();
    const { resources, apptypes } = useDataStore();
    const { setValue, getValues } = useFormContext();
    const [options, setOptions] = useState();
    const [showPicker, setShowPicker] = useState(true);
    useEffect(() => {
        var _a;
        let _options = [];
        if (((_a = props.config) === null || _a === void 0 ? void 0 : _a.showAnyOption) && props.data.length > 1) {
            _options.push({ id: -1, label: t('Geen voorkeur', props.source) });
        }
        props.data.forEach((item) => {
            _options.push({ id: item.id, label: item.name });
        });
        setOptions(_options);
        //setShowPicker(_options.length > (props.config?.showAnyOption ? 2 : 1))
    }, [props]);
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        let sourceHelper = getSourceHelpers((_a = props.source) !== null && _a !== void 0 ? _a : 'apptype');
        if (sourceHelper.type && sourceHelper.options.length > 0) {
            let validObjects = sourceHelper.options.map((object) => object.id);
            if (((_b = props.config) === null || _b === void 0 ? void 0 : _b.showAnyOption) && sourceHelper.options.length > 1) {
                validObjects.push(-1);
            }
            if (sourceHelper.type.length > 0) {
                // we already have a selection, make sure its still valid
                if (validObjects.includes(sourceHelper.type[0])) {
                    setValue(props.source, sourceHelper.type[0]);
                }
                else {
                    if (validObjects.length > 0) {
                        // not valid anymore, set it to the first option, if we have one
                        setValue(props.source, validObjects[0]);
                    }
                }
            }
            else if (sourceHelper.type.length === 0) {
                // there is no selection, but we have options loaded, handle first and false
                if ((_c = props.config) === null || _c === void 0 ? void 0 : _c.defaultValue) {
                    if (((_d = props.config) === null || _d === void 0 ? void 0 : _d.defaultValue) === 'first') {
                        setValue(props.source, sourceHelper.options[0].id);
                        sourceHelper.setter(sourceHelper.options[0].id);
                    }
                    else if (typeof ((_e = props.config) === null || _e === void 0 ? void 0 : _e.defaultValue) == 'number') {
                        if (validObjects.includes((_f = props.config) === null || _f === void 0 ? void 0 : _f.defaultValue)) {
                            // this also handles -1
                            setValue(props.source, (_g = props.config) === null || _g === void 0 ? void 0 : _g.defaultValue);
                        }
                        else {
                            // select the first option if the default option isnt available
                            setValue(props.source, validObjects[0]);
                        }
                    }
                }
                else if (((_h = props.config) === null || _h === void 0 ? void 0 : _h.defaultValue) === false) {
                    // explicitly select nothing
                    let currentOptions = validObjects.filter((option) => option !== -1);
                    if (currentOptions.length === 1) {
                        // if we have only 1 option left, select it
                        setValue(props.source, currentOptions[0]);
                    }
                }
            }
        }
    }, [selectedResource, selectedApptype, selectedCategory, selectedGroup, selectedProduct, resources, apptypes, props]);
    const onChange = (value) => {
        var _a;
        setValue(props.source, value);
        let sourceHelper = getSourceHelpers((_a = props.source) !== null && _a !== void 0 ? _a : 'apptype');
        sourceHelper.setter(parseInt(value));
    };
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        let sourceHelper = getSourceHelpers((_a = props.source) !== null && _a !== void 0 ? _a : 'apptype');
        if ((_b = props.config) === null || _b === void 0 ? void 0 : _b.resetSelection) {
            setSelectedApptype(0);
            setSelectedResource(0);
            setSelectedGroup(0);
        }
        else if (((_c = sourceHelper.type) === null || _c === void 0 ? void 0 : _c.length) === 0) {
            if ((_d = props.config) === null || _d === void 0 ? void 0 : _d.defaultValue) {
                sourceHelper.setter(((_e = props.config) === null || _e === void 0 ? void 0 : _e.defaultValue) === 'first' ? ((_g = (_f = sourceHelper.options[0]) === null || _f === void 0 ? void 0 : _f.id) !== null && _g !== void 0 ? _g : 0) : (_h = props.config) === null || _h === void 0 ? void 0 : _h.defaultValue);
            }
        }
    }, []);
    return (_jsx(_Fragment, { children: showPicker && (_jsx(Box, { sx: { minWidth: 120, my: 1, maxWidth: isLarge ? '500px' : '100%' }, children: _jsx(CustomSelectElement, { id: props.source, name: props.source, label: selectedResource && (selectedResource === null || selectedResource === void 0 ? void 0 : selectedResource.length) > 0 ? t((_b = (_a = props.config) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '') : t(`Selecteer een ${props.source}`), onChange: onChange, options: options }) })) }));
}
